<template>
  <div>
    <!--    二维码弹框-->
    <van-overlay :show="showSverlay">
      <div class="wrapper">
        <div class="block">
          <div class="cross" @click="close">
            <img src="../../assets/login/关闭@2x.png" alt="">
          </div>
          <div class="qr-box">
            <!-- <img src="../../assets/home/71081619072299_.pic_hd.jpg" alt=""> -->
            <img v-if="aiRepQrType=='1'" src="../../assets/airep/GMTUB.png" alt="">
              <img v-if="aiRepQrType=='2'" src="../../assets/airep/GNIQD.png" alt="">
              <img v-if="aiRepQrType=='3'" src="../../assets/airep/GNIPU.png" alt="">
              <img v-if="aiRepQrType=='4'" src="../../assets/airep/GMTLS.png" alt="">
              <img v-if="aiRepQrType=='5'" src="../../assets/airep/GNKUY.png" alt="">
              <img v-if="aiRepQrType=='6'" src="../../assets/airep/GNDAT.png" alt="">
              <img v-if="aiRepQrType=='7'" src="../../assets/airep/GOBGB.png" alt="">
          </div>
          <!-- <div class="message">
            <p>请长按识别下图二维码</p>
            <p>关注公众号</p>
          </div> -->
          <div class="message">
            <p>请长按识别二维码</p>
            <p>添加企业好友，获取更多服务</p>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: "QR",
  props: {
      aiRepQrType:String
  },
  data() {
    return {
      showSverlay: true
    }
  },
  methods: {
    close() {
      let url = localStorage.getItem('history_url')
      if (url) {
        this.$router.push(url)
      } 
      // else {
      //   this.$router.back()
      // }
    },
  }
}
</script>

<style lang="scss" scoped>
.qr-box {
  img {
    width: 100%;
    height: 100%;
  }

  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 10px;
  width: 334px;
  height: 334px;
  background: #ECECEC;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.message {
  margin-top: 20px;
  font-size: 28px;
  font-weight: 400;
  color: #333333;
  line-height: 42px;
}
.block {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 560px;
  height: 618px;
  background-color: #fff;
  border-radius: 20px;
  .cross {
    position: absolute;
    top: 22px;
    right: 22px;
    img {
      width: 34px;
    }
  }
}
</style>
